import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

import JobMarketPageCards, { pickRandomItems } from "./JobMarketPageCards";
import {
  enrichPagesWithCompanies,
  fetchCareerCenterPages,
  filterPagesWithCompany,
} from "./jobMarketHelpers";
import styles from "./styles/jobMarket.module.css";

const PREVIEW_COUNT = 6;
const FETCH_LIMIT = 100;

function JobMarketPages() {
  const [items, setItems] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setLoad(true);
    fetchCareerCenterPages(0, FETCH_LIMIT)
      .then((res) =>
        enrichPagesWithCompanies(
          pickRandomItems(filterPagesWithCompany(res?.data), PREVIEW_COUNT)
        )
      )
      .then((items) => {
        if (!cancelled) {
          setItems(items);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoad(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (load) {
    return (
      <div className={styles.newsLoader}>
        <ClipLoader color="#6E9A10" />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.cardsToolbar}>
        <Link to="/fschool/rynok-truda/vse" className={styles.viewAllLink}>
          Посмотреть все
        </Link>
      </div>
      <JobMarketPageCards items={items} />
    </div>
  );
}

export default JobMarketPages;
